import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const statEmployeeLastExaminationModule: LocaleModule = {
  name: "statEmployeeLastExamination",
  messages: { en: en, it: it },
};
